module.exports = __webpack_public_path__ + "img/back_27.4d68c2a3.svg";